import PropTypes from 'prop-types';

const priorAuthorizationReferralDetailsPropType = PropTypes.shape({
    deniedOn: PropTypes.string,
    followUpPhone: PropTypes.string,
    review: PropTypes.string,
    paNumber: PropTypes.string,
    effectiveStartDate: PropTypes.instanceOf(Date),
    effectiveEndDate: PropTypes.instanceOf(Date),
    methodApprovalReceived: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
    }),
    denialReason: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
    }),
    isPrescriberSubmittingAppeal: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
    }),
    isReAuthorizationRequired: PropTypes.bool,
    reVerificationDueDate: PropTypes.string,
    benefitRequiresReVerification: PropTypes.string,
    reVerificationScheduleOption: PropTypes.string,
    notes: PropTypes.string,
});

export default priorAuthorizationReferralDetailsPropType;
